var CardUrls = {
  ServiceZone: 'serviceZones/{0}/card',
  Road: 'roads/{0}/card',
  SSegment: 'ssegments/{0}/card',
  LongObject: 'longObjects/{0}/card',
  DotObject: 'dotObjects/{0}/card',
  Locality: 'localities/{0}/card',
  Vehicle: 'vehicles/{0}/card',
  Emergency: 'emergencies/{0}/card',
  WStation: 'wstations/{0}/card',
  WStationTooltip: 'wstations/{0}/tooltip',
  Work: 'works/{0}/card',
  VideoCamera: 'videoCameras/{0}/card'
};
